import { HttpRequest } from "@angular/common/http";
import { InMemoryDbService, ParsedRequestUrl, RequestInfo, RequestInfoUtilities, ResponseOptions, STATUS } from "angular-in-memory-web-api";
import { environment } from "src/environments/environment";
import { AgenciaDto } from "../pagamento/models/agencia-dto";
import { CondicaoDocumentoEnum } from "../pagamento/models/condicao-documento-dto";
import { DesmembramentoDto } from "../pagamento/models/desmembramento-dto";
import { PagamentoDto } from "../pagamento/models/pagamento-dto";
import { ParametrosPesquisaPagamento, TipoNivelPesquisa } from "../pagamento/models/parametros-pesquisa";
import { TipoNIRDOC } from "../pagamento/models/tipo-ni-rdoc";
import { AGENCIA_DTO, AUSENCIA_DECLARACAO, BANCO_DTO, BLOQUEIO_MANUAL_DTO, BLOQUEIO_RESTITUICAO_DTO, CAMPOS_ALTERAVEIS, COMPROT_PROCESSOS, COMPROVANTE_PAGAMENTO_PAGTOWEB, COMPROVANTE_PAGAMENTO_RETIFICACAO, CONDICAO_DOCUMENTO_DTO, CREDITO_TRIBUTARIO, DADOS_BASICOS_PF_DTO, DADOS_BASICOS_PJ_DTO, DADOS_CADASTRAIS_PF_DTO, DADOS_RESUMIDOS_PF_DTO, DEBITO_CONTA_CORRENTE_PF_COBRANCA, DEBITO_SICOB, DEBITO_SIEF_COBRANCA, DEBITO_SIEF_EXIGIBILIDADE, DESMEMBRAMENTO_DTO, DETALHE_EVENTO_PJ, DETALHE_HISTORICO_ALTERACAO_PJ, DETALHE_HOMONIMO, DIRPF_DTO, DOCUMENTO_ARRECADACAO_DTO, DOCUMENTO_PESSOA_FISICA_CERTIDAO_NARRATIVA, DOCUMENTO_PESSOA_FISICA_INSCRICAO, DOCUMENTO_PESSOA_FISICA_SITUACAO_CADASTRAL, GENERIC_RESPONSE, INFO_CADASTRAL_PESSOA_JURIDICA_DTO, INSCRICAO_PGFN_COBRANCA, INSCRICAO_PGFN_EXIGIBILIDADE, IRREGULARIDADE_CADASTRAL, MODALIDADE_ARRECADACAO_DTO, NATUREZA_DTO, OPERACAO_HISTORICO, OPERACAO_SUCESSAO, PAGAMENTO_DTO, PROCESSO_SIEF_COBRANCA, PROCESSO_SIEF_EXIGIBILIDADE, QUADRO_SOCIO_PJ_DTO, QUANTIDADE_CNPJS_VINCULADOS_DTO, RECEITA_DTO, RECEITA_DTO_CONSULTA, REGIAO_DTO, RELATORIO, RESUMO_DECLARACAO_OPERACAO_IMOBILIARIA, RESUMO_PESSOA_FISICA, SISTEMA_INTERESSE_DTO_INDICADO, SISTEMA_INTERESSE_DTO_LISTA, SITUACAO_FISCAL_PESSOA_FISICA_DTO, SITUACAO_FISCAL_PESSOA_JURIDICA_DTO, SOCIO_EMPRESA, SOCIO_EMPRESA_HISTORICO, SUMARIO_ANUAL, TIPO_DOCUMENTO_DTO, TITULO_ELEITOR, TRIBUTOS_ACAO_FISCAL, UNIDADE_ADMINISTRATIVA_DTO } from "./entities";
import { FRACAO_DTO } from "./entities/utils/fracao-dto.mock";
import { loadArrayRandom } from "./utils/random";

import { RETORNOVERIFICARETIFICACAO_DTO } from "./entities/pagamentos/retorno-verifica-retificacao-dto.mock";

loadArrayRandom();

// Tipo que representa o mapeamento de URL para funções de tratamento de requisições.
// As chaves são os caminhos das URLs e os valores são funções que recebem um RequestInfo e retornam o corpo da resposta.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RequestMapping = { [key: string]: (ri: RequestInfo) => any };

export class AppInMemoryDataService implements InMemoryDbService {
  public parseRequestUrl(url: string, utils: RequestInfoUtilities): ParsedRequestUrl {
    let endpoint = environment.APIEndpoint;

    if (!endpoint.endsWith("/")) {
      endpoint += "/";
    }

    if (url.indexOf(endpoint) === -1) {
      return utils.parseRequestUrl(url);
    }

    const newPath = this.transformToCustomPath(url.replace(endpoint, ""));
    const newUrl = endpoint + newPath

    const parsed = utils.parseRequestUrl(newUrl);
    const match = parsed.collectionName.match(/\d+/);

    if (match?.length > 0) {
      parsed.id = match[0];
    }

    return parsed;
  }

  public post(requestInfo: RequestInfo) {
    const post_mapping: RequestMapping = {
      "cpf/cadeia-ni/evento-lel/{digits}": () => null,
      "cpf/pesquisa-pessoa-fisica": () => RESUMO_PESSOA_FISICA,
      "cpf/titulo-eleitor": () => [TITULO_ELEITOR],
      "lel/sessao": () => "BBF921735CE24225F826FCA5948FFC379C37B2E08A6D82F8AFB6D3526FBCDF4F",
      "pagamentos/comprovante-retificacao": () => COMPROVANTE_PAGAMENTO_RETIFICACAO,
      "pagamentos/dominio/agencia/getByBanco": (ri: RequestInfo) => this.filtrarAgencias((ri.req as HttpRequest<number>).body),
      "pagamentos/retificacao-completa/campos-alteraveis": () => CAMPOS_ALTERAVEIS,
      "pagamentos/retificacao-simplificada/campos-alteraveis": () => CAMPOS_ALTERAVEIS,
      "pagamentos/search/{digits}/{digits}": (ri: RequestInfo) => this.filtrarPagamentos((ri.req as HttpRequest<ParametrosPesquisaPagamento>).body),
      "pagamentos/searchSaldosDocumento": () => [0, 130.3, 48.86, 15.07],
      "pagamentos/trocaAssinalamento/alterar": () => null,
      "pagamentos/trocaAssinalamento/consultaDocumentoListaNumeroRegistroTroca": () => DOCUMENTO_ARRECADACAO_DTO,
      "pagamentos/trocaAssinalamento/sistemaInteresseIndicado": () => SISTEMA_INTERESSE_DTO_INDICADO,
      "pagamentos/trocaAssinalamento/sistemasInteresse/list": () => SISTEMA_INTERESSE_DTO_LISTA,
      "pagamentos/trocaAssinalamento/verificarTrocaAssinalamento": () => true,
      "situacoesfiscais/protocolos": () => "000000000000203648300010013020000047510896843",
      "pagamentos/retificacao/verificaRetificacao": () => RETORNOVERIFICARETIFICACAO_DTO,
      "pagamentos/retificacao/verificaRetificacaoSimplificada": () => RETORNOVERIFICARETIFICACAO_DTO,
      "pagamentos/retificacao/retificaDocumento": () => RETORNOVERIFICARETIFICACAO_DTO,
      "pagamentos/retificacao/retificaDocumentoSimplificada": () => RETORNOVERIFICARETIFICACAO_DTO
    };

    return this.handleRequests(requestInfo, post_mapping);
  }

  public put(requestInfo: RequestInfo) {
    const put_mapping: RequestMapping = {
      "pagamentos/retificacao-completa": () => null,
    };

    return this.handleRequests(requestInfo, put_mapping);
  }

  public get(requestInfo: RequestInfo) {
    const get_mapping: RequestMapping = {
      "acaofiscal/tributos/{digits}/{digits}-{digits}-{digits}": () => TRIBUTOS_ACAO_FISCAL,
      "cafir/{digits}/imoveis": () => [],
      "cnpj/operacoes-sucessao/{digits}": () => OPERACAO_SUCESSAO,
      "cnpj/vinculados/{digits}": () => GENERIC_RESPONSE,
      "cnpj/vinculados/{digits}/quantidade": () => QUANTIDADE_CNPJS_VINCULADOS_DTO,
      "cnpj/{digits}": () => DADOS_BASICOS_PJ_DTO,
      "cnpj/{digits}/eventos": () => DETALHE_EVENTO_PJ,
      "cnpj/{digits}/historico": () => DETALHE_HISTORICO_ALTERACAO_PJ,
      "cnpj/{digits}/historico-socios": () => SOCIO_EMPRESA_HISTORICO,
      "cnpj/{digits}/socios": () => SOCIO_EMPRESA,
      "cobranca/ccpf/creditos-tributarios/{digits}/{digits}/exercicio": () => CREDITO_TRIBUTARIO,
      "comprot/{digits}/processos": () => COMPROT_PROCESSOS,
      "cpf/dados-basicos/{digits}": () => DADOS_BASICOS_PF_DTO,
      "cpf/documentos/comprovante-certidao-narrativa/{digits}": () => DOCUMENTO_PESSOA_FISICA_CERTIDAO_NARRATIVA,
      "cpf/documentos/comprovante-inscricao/{digits}": () => DOCUMENTO_PESSOA_FISICA_INSCRICAO,
      "cpf/documentos/comprovante-situacao-cadastral/{digits}": () => DOCUMENTO_PESSOA_FISICA_SITUACAO_CADASTRAL,
      "cpf/historico-operacoes/{digits}": () => OPERACAO_HISTORICO,
      "cpf/homonimos/{digits}": () => DETALHE_HOMONIMO,
      "cpf/resumo/{digits}": () => DADOS_RESUMIDOS_PF_DTO,
      "cpf/titulo-eleitor/{digits}": () => TITULO_ELEITOR,
      "declaracoes-irpf/{digits}/dirpfs": () => DIRPF_DTO,
      "declaracoes-irpf/{digits}/em-malha/quantidade": () => 10,
      "dirf/{digits}/retencoes": () => SUMARIO_ANUAL,
      "doi/{digits}/declaracoes": () => RESUMO_DECLARACAO_OPERACAO_IMOBILIARIA,
      "pagamentos/bloqueiosManuais/{digits}": () => BLOQUEIO_MANUAL_DTO,
      "pagamentos/bloqueiosRestituicao/{digits}": () => BLOQUEIO_RESTITUICAO_DTO,
      "pagamentos/desmembramento/searchByNumeroDocumento/{digits}": () => DESMEMBRAMENTO_DTO,
      "pagamentos/dominio/banco/getAll": () => BANCO_DTO,
      "pagamentos/dominio/condicao/getAll": () => CONDICAO_DOCUMENTO_DTO,
      "pagamentos/dominio/delegacia/getAll": () => UNIDADE_ADMINISTRATIVA_DTO,
      "pagamentos/dominio/modalidade/getAll": () => MODALIDADE_ARRECADACAO_DTO,
      "pagamentos/dominio/natureza/getAll": () => NATUREZA_DTO,
      "pagamentos/dominio/receita/getAll": () => RECEITA_DTO,
      "pagamentos/dominio/regiao/getAll": () => REGIAO_DTO,
      "pagamentos/dominio/tipoDocumento/getAll": () => TIPO_DOCUMENTO_DTO,
      "pagtoweb/comprovante-pagamento/{digits}": () => COMPROVANTE_PAGAMENTO_PAGTOWEB,
      "sief-receitas/{digits}": () => RECEITA_DTO_CONSULTA,
      "situacoesfiscais/ausenciasdeclaracao/{digits}/GFIP": () => AUSENCIA_DECLARACAO,
      "situacoesfiscais/irregularidades/CNPJ/{digits}": () => IRREGULARIDADE_CADASTRAL,
      "situacoesfiscais/liberacao/CPF/{digits}": () => [],
      "situacoesfiscais/pessoasfisicas/{digits}": (ri: RequestInfo) => SITUACAO_FISCAL_PESSOA_FISICA_DTO.map((dto) => { return { ...dto, ni: ri.id ?? dto.ni }; }),
      "situacoesfiscais/pessoasfisicas/{digits}/ccpf/Cobranca": () => DEBITO_CONTA_CORRENTE_PF_COBRANCA,
      "situacoesfiscais/pessoasfisicas/{digits}/informacoescadastrais": () => DADOS_CADASTRAIS_PF_DTO,
      "situacoesfiscais/pessoasjuridicas/{digits}": (ri: RequestInfo) => SITUACAO_FISCAL_PESSOA_JURIDICA_DTO.map((dto) => { return { ...dto, ni: ri.id ?? dto.ni }; }),
      "situacoesfiscais/pessoasjuridicas/{digits}/informacoescadastrais": () => INFO_CADASTRAL_PESSOA_JURIDICA_DTO,
      "situacoesfiscais/pessoasjuridicas/{digits}/quadrosociosadministradores": () => QUADRO_SOCIO_PJ_DTO,
      "situacoesfiscais/pgfn/inscricoes/{digits}/Cobranca": () => INSCRICAO_PGFN_COBRANCA,
      "situacoesfiscais/pgfn/inscricoes/{digits}/Exigibilidade": () => INSCRICAO_PGFN_EXIGIBILIDADE,
      "situacoesfiscais/protocolos": () => { return { "data": "2025-04-28T09:03:26", "situacao": "Finalizada" }; },
      "situacoesfiscais/relatorio/CNPJ/{digits}": () => RELATORIO[0],
      "situacoesfiscais/relatorio/CPF/{digits}": () => RELATORIO[1],
      "situacoesfiscais/sicob/debito/Exigibilidade/{digits}": () => DEBITO_SICOB,
      "situacoesfiscais/sief/debitos/{digits}/Cobranca": () => DEBITO_SIEF_COBRANCA,
      "situacoesfiscais/sief/debitos/{digits}/Exigibilidade": () => DEBITO_SIEF_EXIGIBILIDADE,
      "situacoesfiscais/sief/processos/{digits}/Cobranca": () => PROCESSO_SIEF_COBRANCA,
      "situacoesfiscais/sief/processos/{digits}/Exigibilidade": () => PROCESSO_SIEF_EXIGIBILIDADE,
    };

    return this.handleRequests(requestInfo, get_mapping);
  }

  public createDb() {
    const loggeduser = {
      "name": "USUÁRIO 1",
      "roles": [
        {
          "id": "ATENDEARFB",
          "name": "ATENDEARFB"
        },
        {
          "id": "ATENDENTE",
          "name": "ATENDENTE"
        },
        {
          "id": "CONSULTA",
          "name": "CONSULTA"
        },
        {
          "id": "GERENCIAL1",
          "name": "GERENCIAL1"
        },
        {
          "id": "GERENCIAL2",
          "name": "GERENCIAL2"
        }
      ],
      "profiles": [
        {
          "id": "ATENDEARFB",
          "name": "ATENDEARFB"
        },
        {
          "id": "ATENDENTE",
          "name": "ATENDENTE"
        },
        {
          "id": "CONSULTA",
          "name": "CONSULTA"
        },
        {
          "id": "GERENCIAL1",
          "name": "GERENCIAL1"
        },
        {
          "id": "GERENCIAL2",
          "name": "GERENCIAL2"
        }
      ]
    }

    return {
      loggeduser,
      info: environment.version,
    };
  }

  /**
   * Transforma o caminho da URL para um formato customizado.
   * Remove os hífens e substitui as barras por dois underscores.
   * 
   * Não achei uma forma de mapear os caminhos no Angular InMemory Web API.
   * Ver método {createDb} desse arquivo.
   * 
   * Exemplo: caminho/simples-exemplo => caminho__simplesexemplo
   */
  private transformToCustomPath(path: string): string {
    return path.replace(/\/+/g, "__").replace(/-+/g, "");
  }

  private handleRequests(requestInfo: RequestInfo, mapping: RequestMapping) {
    const options: ResponseOptions = {
      status: STATUS.OK,
      headers: requestInfo.headers,
      url: requestInfo.url
    };

    let foundCustomHandler = false;

    for (const url in mapping) {
      const newUrl = this.transformToCustomPath(url).replace(/\{digits\}/g, "\\d+");
      const regex = new RegExp(`\\b${newUrl}\\b`);

      if (requestInfo.collectionName.match(regex)) {
        options.body = mapping[url](requestInfo);
        foundCustomHandler = true;

        console.debug(requestInfo.url);
        console.debug(options.body);
        break;
      }
    }

    if (!foundCustomHandler) {
      return null;
    }

    return requestInfo.utils.createResponse$(() => options);
  }

  private gerarComposicao(): DesmembramentoDto[] {
    return [
      {
        cnpjOrdemDebito: 0,
        cnpjPrestador: 1,
        cpfDebito: 2,
        cpfSegurado: 3,
        dataVencimento: new Date(),
        fracoes: [
          FRACAO_DTO.random(),
          FRACAO_DTO.random(),
          FRACAO_DTO.random(),
          FRACAO_DTO.random(),
        ],
        numeroCadastroNacionalObras: 4,
        numeroCib: "A",
        numeroIdentificacaoTrabalhador: 5,
        numeroInscricaoDAU: 6,
        periodoApuracao: new Date(),
        processo: "B",
        procInfoComplementar: "C",
        referencia: "D",
        sequencialDesmembramento: 7,
        sistemaInteresse: {
          codigo: 8,
          descricao: "E",
        },
        situacao: "F",
        unidadeFederativaSigla: "G",
        valorTotal: 9,
      },
      {
        cnpjOrdemDebito: 10,
        cnpjPrestador: 11,
        cpfDebito: 12,
        cpfSegurado: 13,
        dataVencimento: new Date(),
        fracoes: [
          FRACAO_DTO.random(),
          FRACAO_DTO.random(),
          FRACAO_DTO.random(),
          FRACAO_DTO.random(),
        ],
        numeroCadastroNacionalObras: 14,
        numeroCib: "H",
        numeroIdentificacaoTrabalhador: 15,
        numeroInscricaoDAU: 16,
        periodoApuracao: new Date(),
        processo: "I",
        procInfoComplementar: "J",
        referencia: "K",
        sequencialDesmembramento: 17,
        sistemaInteresse: {
          codigo: 18,
          descricao: "L",
        },
        situacao: "M",
        unidadeFederativaSigla: "N",
        valorTotal: 19,
      },
    ]
  }

  private filtrarAgencias(codigoBanco: number): AgenciaDto[] {
    return AGENCIA_DTO.filter((agencia) => {
      if (codigoBanco != null) {
        return agencia.banco.codigo === codigoBanco;
      }

      return true;
    }).sort((a, b) => a.codigo - b.codigo);
  }

  private filtrarPagamentos(parametros: ParametrosPesquisaPagamento) {
    console.debug(parametros);

    const filtro: Partial<PagamentoDto> = {
      pgtoNr: parametros?.numeroPagamento?.replace(/^0+/, ""),
      pgtoNrIdAr: parametros?.numeroDocumento?.replace(/^0+/, ""),
      tipoDocumento: parametros?.tipoDocumento,
      pgtoNrReferencia: parametros?.numeroReferencia,
      pgtoAgenAgtaCd: parametros?.banco?.codigo,
      pgtoAgenCd: parametros?.agencia?.codigo,
      natureza: parametros?.naturezaDocumento,
      receita01: parametros?.receita,
      modalidadeArrecadacao: parametros?.modalidadeArrecadacao,
    };

    // Trata parâmetro {debitosNaoEfetivadosDaraOnline}
    if (parametros?.debitosNaoEfetivadosDaraOnline != null) {
      filtro.pgtoInDara = parametros.debitosNaoEfetivadosDaraOnline ? "S" : "N";
    }

    // Trata parâmetro {niSemDv}
    if (parametros.niSemDv != null && parametros.niSemDv.ni != null && parametros.niSemDv.ni != "") {
      if (parametros.niSemDv.tipoNi == TipoNIRDOC.CPF) {
        filtro.pgtoPfNr = parseInt(parametros.niSemDv.ni);
      }
      else if (parametros.niSemDv.tipoNi == TipoNIRDOC.CNPJ) {
        filtro.pgtoEstbPjNr = parseInt(parametros.niSemDv.ni.substring(0, 8));
        filtro.pgtoEstbNr = parseInt(parametros.niSemDv.ni.substring(8, 12));
      }
      else {
        filtro.pgtoNrContribNident = parametros.niSemDv.ni;
      }
    }

    Object.keys(filtro).forEach((k) => {
      if (filtro[k] == null || filtro[k] === "") {
        delete filtro[k];
      }
    });

    return PAGAMENTO_DTO.filter((pagamento) => {
      for (const key in filtro) {
        let valorFiltro = filtro[key];
        let valorDado = pagamento[key];

        if (typeof filtro[key] === "object" && "codigo" in filtro[key]) {
          valorFiltro = filtro[key]?.codigo;
          valorDado = pagamento[key]?.codigo;
        }

        if (valorFiltro != valorDado) {
          return false;
        }
      }

      // Trata parâmetro {condicaoDocumento}
      if (parametros.condicaoDocumento != null && parametros.condicaoDocumento.codigo != null) {
        // Não tenho certeza do que caracteriza um pagamento agendado ou emitido.
        // Esses foram apenas os atributos deduzidos a partir dos dados obtidos em homologação.
        const isAgendado = pagamento.agendado === true;
        const isEmitido = pagamento.pgtoInDara === "S" && pagamento.pago === false;

        switch (parametros.condicaoDocumento.codigo) {
          case CondicaoDocumentoEnum.PAGO:
            if (isAgendado || isEmitido) {
              return false;
            }
            break;

          case CondicaoDocumentoEnum.EMITIDO:
            if (!isEmitido) {
              return false;
            }
            break;

          case CondicaoDocumentoEnum.AGENDADO:
            if (!isAgendado) {
              return false;
            }
            break;

          default:
            throw Error(`Condição de documento desconhecida: ${parametros.condicaoDocumento.codigo}`);
        }
      }

      // Trata parâmetro {periodoArrecadacao}
      const dataInicial = parametros?.periodoArrecadacao?.dataInicial;
      const dataFinal = parametros?.periodoArrecadacao?.dataFinal;

      if (dataInicial != null && dataInicial instanceof Date && this.compararDatas(this.converterParaData(pagamento?.pgtoDtArrecadacao), dataInicial) < 0) {
        return false;
      }

      if (dataFinal != null && dataFinal instanceof Date && this.compararDatas(this.converterParaData(pagamento?.pgtoDtArrecadacao), dataFinal) > 0) {
        return false;
      }

      // Trata parâmetro {faixaArrecadacao}
      const valorInicial = parametros?.faixaArrecadacao?.valorInicial;
      const valorFinal = parametros?.faixaArrecadacao?.valorFinal;

      if (valorInicial != null && pagamento.pgtoVlTotal < valorInicial) {
        return false;
      }

      if (valorFinal != null && pagamento.pgtoVlTotal > valorFinal) {
        return false;
      }

      // Trata parâmetro {nivelPesquisa}
      if (parametros.nivelPesquisa != null && parametros.nivelPesquisa.tipo != null && parametros.nivelPesquisa.valor != null) {
        if (parametros.nivelPesquisa.tipo === TipoNivelPesquisa.DELEGACIA) {
          const delegacia: string = parametros.nivelPesquisa.valor.toString().slice(0, -2).padStart(5, "0");

          if (pagamento.pgtoUa == null || pagamento.pgtoUa != delegacia) {
            return false;
          }
        }
        else if (parametros.nivelPesquisa.tipo === TipoNivelPesquisa.REGIAO) {
          const regiao: string = parametros.nivelPesquisa.valor.toString();

          if (pagamento.pgtoUa == null || !pagamento.pgtoUa.startsWith(regiao)) {
            return false;
          }
        }
      }

      return true;
    });
  }

  private compararDatas(a: Date, b: Date): number {
    if (a.getFullYear() > b.getFullYear()) { return 1; }
    if (a.getFullYear() < b.getFullYear()) { return -1; }
    if (a.getMonth() > b.getMonth()) { return 1; }
    if (a.getMonth() < b.getMonth()) { return -1; }
    if (a.getDate() > b.getDate()) { return 1; }
    if (a.getDate() < b.getDate()) { return -1; }

    return 0;
  }

  private converterParaData(data: string | number): Date {
    // O trecho {T12:00:00.000Z} garante que a data seja convertida corretamente sem a margem de erro de 1 dia
    const horario = "T12:00:00.000Z";

    if (typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}$/) != null) {
      data += horario;
    }

    if (typeof data === 'number') {
      data = data.toString().replace(/(\d{4})(\d{2})(\d{2})/, `$1-$2-$3${horario}`);
    }

    return new Date(data);
  }
}